import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import { registerUser, clearError } from '../store/slices/authSlice';
import { fetchRoles } from '../store/slices/roleSlice';
import { toast } from '../utils/toast';

export default function SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error, user } = useSelector((state) => state.auth);
  const { roles } = useSelector((state) => state.role);

  const [showPassword, setShowPassword] = useState(false);
  const [formState, setFormState] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: ""
  })

  // useEffect(() => {
  //   dispatch(fetchRoles({ filter: { name: "Customer" } }));
  //   return () => {
  //     dispatch(clearError());
  //   };
  // }, [dispatch]);

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formState.firstname || !formState.email || !formState.password || !formState.phone) {
      toast.warning("Please fill all required fields");
      return;
    }

    if (formState.phone.length !== 10 || isNaN(Number(formState.phone))) {
      toast.warning("Please enter a valid 10-digit phone number");
      return;
    }

    const customerRole = roles.find(r => r.name === "Customer") || roles[0];

    // if (!customerRole) {
    //   alert("System roles not loaded yet. Please try again.");
    //   dispatch(fetchRoles());
    //   return;
    // }

    dispatch(registerUser({
      first_name: formState.firstname,
      last_name: formState.lastname,
      email: formState.email,
      phone_number: formState.phone,
      password: formState.password,
      role: customerRole?._id || [3]
    }));
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f7fafc',
      padding: '48px 24px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '450px',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px'
      }}>
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <h1 style={{ fontSize: '36px', fontWeight: 'bold', margin: 0 }}>Sign up</h1>
          <p style={{ fontSize: '18px', color: '#718096', margin: 0 }}>
            Looks like you're new here! ✌️
          </p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          padding: '32px'
        }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '14px', fontWeight: '500', color: '#4a5568' }}>First Name *</label>
                <input
                  type="text"
                  name="firstname"
                  value={formState.firstname}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '14px', fontWeight: '500', color: '#4a5568' }}>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  value={formState.lastname}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#4a5568' }}>Email address *</label>
              <input
                type="email"
                name="email"
                value={formState.email}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#4a5568' }}>Phone Number *</label>
              <input
                type="tel"
                name="phone"
                value={formState.phone}
                onChange={handleChange}
                required
                maxLength="10"
                placeholder="10-digit mobile number"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#4a5568' }}>Password *</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formState.password}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 40px 8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#718096'
                  }}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            {error && (
              <div style={{ color: '#e53e3e', fontSize: '14px', textAlign: 'center' }}>
                {error}
              </div>
            )}

            <div style={{ marginTop: '16px' }}>
              <button
                type="submit"
                disabled={status === 'loading'}
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: status === 'loading' ? '#a0aec0' : '#4299e1',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: status === 'loading' ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => { if (status !== 'loading') e.target.style.backgroundColor = '#3182ce' }}
                onMouseOut={(e) => { if (status !== 'loading') e.target.style.backgroundColor = '#4299e1' }}
              >
                {status === 'loading' ? 'Signing up...' : 'Sign up'}
              </button>
            </div>
            <div style={{ marginTop: '24px', textAlign: 'center' }}>
              <p style={{ margin: 0, fontSize: '14px' }}>
                Already a user? <Link to="/login" style={{ color: '#4299e1', textDecoration: 'none' }}>Login</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}